import { Divider, Group, ScrollArea, Stack } from '@mantine/core';
import { useCostTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setCostMode } from '../../../../../store/strategy-store/strategy-store.actions';
import { Select } from '../../../../../ui-library/select/select';
import { SmallSquareButton } from '../../../../financials/charts/shared/small-square-button';
import { isEnabledEpicSearch } from '../../initiative-performance.helpers';
import { getCostModeOptions } from '../cost-tab.helpers';
import { useCostEpics } from '../cost-tab.hooks';
import { CostMode } from '../cost-tab.type';
import { FiltersList } from './filters-list';
import { FiltersSearch } from './filters-search';

export const Filters = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const mode = useCostTabStore((state) => state.mode);
  const epics = useCostEpics();

  const handleModeChange = (value: string) => {
    setCostMode(value as CostMode);
  };

  return (
    <Stack gap="md" h="100%">
      <Group justify="space-between">
        <Select options={getCostModeOptions()} value={mode} onChange={handleModeChange} />
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
      </Group>
      <Divider />
      {mode === CostMode.ContributingEpics && isEnabledEpicSearch(epics) && (
        <>
          <FiltersSearch />
          <Divider />
        </>
      )}
      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <FiltersList />
      </ScrollArea>
    </Stack>
  );
};
